export default ({ request }) => ({
  stockSampleLocationListApi(data = {}) {
    return request({
      url: '/samplemanage/stockSampleLocation/list',
      method: 'post',
      data
    })
  },
  stockSampleLocationDetailByBarcodeApi(data = {}) {
    return request({
      url: '/samplemanage/stockSampleLocation/detail/bySampleBarcode',
      method: 'post',
      data
    })
  },
  stockSampleLocationExportCheckApi(data = {}) {
    return request({
      url: '/samplemanage/stockSampleLocation/export/check',
      method: 'post',
      data
    })
  },
  stockSampleLocationDetailSampleBarcodeApi(data = {}) {
    return request({
      url: '/samplemanage/stockSampleLocation/detail/sampleBarcode',
      method: 'post',
      data
    })
  },
  stockSampleLocationChangeLocationApi(data = {}) {
    return request({
      url: '/samplemanage/stockSampleLocation/changeLocation',
      method: 'post',
      data
    })
  },
  warehouseTreeApi(data = {}) {
    return request({
      url: '/digitalCenter/master/warehouse/treeList',
      method: 'post',
      data,
    })
  },
  masterStorageLocationListApi(data = {}) {
    return request({
      url: '/samplemanage/masterStorageLocation/list',
      method: 'post',
      data
    })
  },
  masterStorageLocationPrintApi(data = {}) {
    return request({
      url: '/samplemanage/masterStorageLocation/print',
      method: 'post',
      data
    })
  },
  masterStorageLocationRelocationApi(data = {}) {
    return request({
      url: '/samplemanage/masterStorageLocation/relocation',
      method: 'post',
      data
    })
  },
})
